<template>
    <div class="page-contact">
        <!-- <Header /> -->
        <main class="page-contact__main">
            <section class="section__intro">
                <div class="section__intro-logo">
                    <img src="~/assets/images/PANTHERE2026_WEB_1080.png" alt="Des personnes se serrent la main" />
                </div>
                <div class="section__intro-resume">
                    <h1 class="section-title">
                        <span class="section-subtitle">Baghera Advisory</span>
                        <br />Contact
                    </h1>
                    <p class="section-content">
                        Nous sommes à votre écoute.
                    </p>
                    <p class="section-content">
                        Grégory SACHNINE est à votre disposition pour répondre à vos questions,
                        discuter de vos enjeux stratégiques, et travailler ensemble pour
                        atteindre vos objectifs.
                    </p>
                    <ButtonAnchor to="/presentation-corporate-baghera-advisory-01-2026.pdf" blank class="mt-4 mb-2">Téléchargez la plaquette</ButtonAnchor>

                    <!-- <NuxtLink to="/" class="nav-link">Retour à l'accueil</NuxtLink> -->
                </div>
            </section>

            <section class="section__contact">
                <h2 class="section__contact-title">Vous souhaitez échanger avec nous ?</h2>

                <div class="section__contact-info mt-10">
                    <a href="mailto:g.sachnine@baghera-advisory.fr" class="contact-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <rect width="20" height="16" x="2" y="4" rx="2"/>
                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
                        </svg>
                        <span>g.sachnine@baghera-advisory.fr</span>
                    </a>
                    <a href="tel:+33677956904" class="contact-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                        </svg>
                        <span>(+33) 06 77 95 69 04</span>
                    </a>
                    <div class="contact-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                            <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/>
                            <circle cx="12" cy="10" r="3"/>
                        </svg>
                        <span>Pessac (33600)</span>
                    </div>
                </div>

                <ButtonAnchor class="mt-20" /> 
            </section>

            <Footer />
        </main>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
  title: 'Contact - Baghera Advisory',
  description: 'Contactez Baghera Advisory pour discuter de vos enjeux stratégiques. Grégory Sachnine est à votre écoute. Tél: (+33) 06 77 95 69 04',
  ogTitle: 'Contact - Baghera Advisory',
  ogDescription: 'Contactez Baghera Advisory pour discuter de vos enjeux stratégiques. Nous sommes à votre écoute.',
  ogImage: 'https://baghera-advisory.fr/img/desktop/panther_1440x532.webp',
  ogImageWidth: 1440,
  ogImageHeight: 532,
  ogType: 'website',
  ogLocale: 'fr_FR',
  ogSiteName: 'Baghera Advisory',
  ogUrl: 'https://baghera-advisory.fr/contact',
  twitterCard: 'summary_large_image',
  twitterTitle: 'Contact - Baghera Advisory',
  twitterDescription: 'Contactez Baghera Advisory pour discuter de vos enjeux stratégiques. Nous sommes à votre écoute.',
  twitterImage: 'https://baghera-advisory.fr/img/desktop/panther_1440x532.webp',
})

useStructuredData({
  breadcrumbs: [
    { name: 'Accueil', url: '/' },
    { name: 'Contact', url: '/contact' },
  ],
})
</script>

<style scoped lang="postcss">
.page-contact {
    @apply flex flex-col items-center w-full min-h-screen bg-primary
    laptop:max-w-[1440px] laptop:mx-auto;

    &__main {
        @apply relative flex flex-col flex-1 mt-[100px] z-10;
    }
}

.section {
    &-title {
        @apply text-secondary text-3xl font-light mb-8;
    }

    &-subtitle {
        @apply text-secondary font-light text-xl;
    }

    &-content {
        @apply text-primary text-lg mb-6;
    }

    &__intro {
        @apply flex flex-col w-full laptop:flex-row;

        &-logo {
            @apply flex justify-center items-center bg-primary w-full
            laptop:w-1/2;

            img {
                @apply w-full h-full object-cover;
            }
        }

        &-resume {
            @apply flex justify-center items-start flex-col bg-tertiary py-20 px-8
            laptop:px-28;
        }
    }

    &__contact {
        @apply flex flex-col flex-1 items-center bg-secondary py-20 px-8 w-full
        laptop:px-28;

        &-title {
            @apply text-tertiary text-3xl font-light mb-4 text-center;
        }

        &-subtitle {
            @apply text-primary text-lg mb-10 text-center;
        }

        &-info {
            @apply flex flex-col gap-6 items-start
            laptop:flex-row laptop:gap-12 laptop:items-center;
        }
    }
}

.contact-item {
    @apply flex items-center gap-3 text-primary text-lg
    transition-colors duration-300;

    svg {
        @apply text-tertiary flex-shrink-0;
    }

    &:hover {
        @apply text-tertiary;
    }
}

a.contact-item {
    @apply underline-offset-4 hover:underline;
}

.nav-link {
    @apply inline-flex items-center justify-center gap-2 px-6 py-3 mt-4
    bg-primary text-tertiary rounded-4xl
    transition-colors duration-300
    hover:bg-secondary hover:text-white
    focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2;
}
</style>
